import React from 'react'
import CustomSlider from './CustomSlider'


const customSliderContainer = ({ containerObject, templateName, contentId, dataZone }) => {
  return (
    <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={` ${containerObject.attributes.articleContainerRendering} ${containerObject.attributes.class} vast-plugin-content row g-0 mb-2`} >
                <CustomSlider containerObject={containerObject}/>
          </div>
  )
}

export default customSliderContainer